import * as Phaser from 'phaser';

/**
 * BootScene — minimal environmental setup before the preload spinner.
 * Kept thin on purpose: Phaser is still initialising, nothing async yet.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  create(): void {
    this.cameras.main.setBackgroundColor('#050505');
    this.scene.start('PreloadScene');
  }
}
